var FileScanStatus;
(function (FileScanStatus) {
  FileScanStatus["PASSED"] = "passed";
  FileScanStatus["MALWARE"] = "malware";
  FileScanStatus["INPROGRESS"] = "in progress";
})(FileScanStatus || (FileScanStatus = {}));
export default FileScanStatus;